import { mergeWith } from "lodash/fp";
const mergeAndConcat = mergeWith((a, b) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return [...a, ...b];
  }
});
export { mergeAndConcat as default };